import { Avatar, Box, Text } from '@wix/design-system';
import { UserContactsSection } from '@wix/wix-help-widget-common/homepage';
import { useTranslation } from '@wix/wix-i18n-config';
import React, { FC } from 'react';

import { userContactsDataHooks } from './UserContacts.dataHooks';
import { UserContactsEmail } from './UserContactsEmail';

type UserContactsTeamProps = Pick<UserContactsSection, 'email'>;

export const UserContactsTeam: FC<UserContactsTeamProps> = ({ email }) => {
  const { t } = useTranslation();

  return (
    <Box width="100%" direction="vertical" gap={2} padding="18px">
      <Box gap={2} verticalAlign="top">
        <Avatar
          color="A1"
          size="size36"
          name={t('home_contact_team_avatar')}
          dataHook={userContactsDataHooks.avatar()}
        />
        <Box direction="vertical" gap={1}>
          <Text
            size="small"
            weight="bold"
            dataHook={userContactsDataHooks.name()}
          >
            {t('home_contact_team_name')}
          </Text>
          <Text size="tiny" dataHook={userContactsDataHooks.phoneNumber()}>
            {t('home_contact_team_description')}
          </Text>
        </Box>
      </Box>
      <UserContactsEmail email={email} />
    </Box>
  );
};
